<template>
  <div class="w-[100vw] bg-[#0d1116] flex items-center justify-center">
    <div class="flex flex-col items-center justify-center w-[500px] bg-gray-800 p-4 rounded">
      <h1 class="text-2xl font-bold">About</h1>
      <p class="m-4 text-center">This is just a dummy app for me to practice and walk around awesome vue 3 and try different libraries and API with it, so you can continue with your work. Thankyou, BTW checkout my GitHub hahaaha!</p>
    </div>
  </div>
</template>
